import React, { useState } from 'react';
import './App.css';
import { useNavigate } from 'react-router-dom';
import { getGlobalDealerName, setGlobalDealerID } from './globalState';
import { getBrand } from './brands';
import api, { setSessionToken } from './api';
import BackButton from './BackButton';

function DealerID() {
  /*
  DealerID component allows users to enter their Dealer ID and submit it to the backend.
  A successful validation returns a session token that authorizes the rest of the
  photo-submission flow for this dealer.
  */
  const [dealerID, setID] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleIDChange = (event) => {
    setID(event.target.value);
  };

  const handleCheckmarkClick = async () => {
    if (!dealerID) {
      alert('Please enter a Dealer ID.');
      return;
    }
    setErrorMessage('');
    const dealerName = getGlobalDealerName();
    if (!dealerName) {
      alert('Please select a dealership brand first.');
      return;
    }

    setIsLoading(true);
    try {
      const response = await api.post('/api/send-ID', { dealerID, dealerName });

      if (response.data.found) {
        setSessionToken(response.data.token);
        setGlobalDealerID(dealerID);
        // Brands in the plates/frames program get the phototype chooser;
        // the rest go straight to the dealership photo flow (brands.js).
        if (getBrand(dealerName)?.platesProgram) {
          navigate('/choose-phototype');
        } else {
          navigate('/quick-start-guide');
        }
      } else {
        setErrorMessage('No dealer found for the given ID. Please enter a valid ID for your chosen brand.');
      }
    } catch (error) {
      console.error('Error sending ID to backend:', error);
      setErrorMessage('We could not reach the server. Please check your connection and try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="DealerID">
      <h1 className="DealerID-title">Dealer ID</h1>
      <p className="DealerID-subtitle">
        Please enter your Dealer ID below. This will help us identify your dealership and ensure that the photos are sent to the correct location.
      </p>
      <div className="DealerID-form">
        <label htmlFor="contact-ID" className="DealerID-label">Dealer ID:</label>
        <input
          type="text"
          id="contact-ID"
          className="DealerID-input"
          value={dealerID}
          onChange={handleIDChange}
          placeholder="Enter Dealer ID"
        />
      </div>
      {errorMessage && <p className="DealerID-error">{errorMessage}</p>}
      {isLoading && <p className="DealerID-loading">Searching for your dealer...</p>}
      <button className="DealerID-check-button" onClick={handleCheckmarkClick} disabled={isLoading}>
        ✓
      </button>
      <BackButton />
    </div>
  );
}

export default DealerID;
